import { useClassNames } from "../../../structure";
import { ParagraphProps } from "./Paragraph.types";

export default function Paragraph({ children, classNames }: ParagraphProps) {
  const style = useClassNames(["b1Regular", ...(classNames || [])]);
  return <p style={style}>{children}</p>;
}
